import { useEffect, useState } from "react";
import { components } from "react-select";
import CreatableSelect from "react-select/creatable";
import { Box, Flex } from "rebass";
import { getLocalizedString } from "../../utils";
import { GoMail } from "react-icons/go";

const selectStyle = {
  control: (styles) => ({
    ...styles,
    border: 0,
    borderRadius: 0,
    backgroundColor: "#a1a1a1",
    marginTop: 0,
    boxShadow: "none",
    color: "#fff",
  }),
  menu: (styles) => ({
    ...styles,
    padding: 0,
    borderRadius: 0,
    backgroundColor: "#a1a1a1",
    marginTop: 0,
    marginBottom: 0,
    boxShadow: "none",
  }),
  option: (styles, state) => ({
    ...styles,
    marginTop: 1,
    marginBottom: 1,
    color: "#fff",
    fontWeight: 600,
    ...(state.isFocused && {
      backgroundColor: "hsl(0, 0%, 90%)",
      color: "black",
    }),
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "black",
  }),
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
};
const SelectOrderEmail = ({
  order,
  selectedEmails,
  setSelectedEmails,
  sx,
  ...props
}) => {
  const [emailOptions, setEmailOptions] = useState([]);
  const [errors, setErrors] = useState([]);

  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

  useEffect(() => {
    if (order?.customData?.emails?.length) {
      const options = order.customData.emails.map((email) => ({
        label: email,
        value: email,
        isDefault: false //adg 09/10/2024 rimosse le mail di default (preselezionate) email === order?.customData?.orderTO,
      }));
      setEmailOptions(options);

      setSelectedEmails(options.filter((option) => option.isDefault));
    }
  }, [order]);

  const handleAddEmail = (inputValue) => {
    const newOption = {
      label: inputValue,
      value: inputValue,
    };
    setEmailOptions([...emailOptions, newOption]);
    setSelectedEmails([...selectedEmails, newOption]);
  };

  return (
    <Flex
      sx={{
        alignItems: "center",
        flex: 1,
        gap: "1em",
        ...sx,
      }}
    >
      <GoMail style={{ width: "32px", height: "32px", color: "#a1a1a1" }} />
      <Box sx={{ flex: 1 }}>
        <CreatableSelect
          isMulti
          isClearable={false}
          backspaceRemovesValue={false}
          components={{ MultiValueRemove }}
          options={emailOptions}
          onChange={(newValue) => setSelectedEmails(newValue)}
          onInputChange={() => {
            setErrors([]);
          }}
          onCreateOption={handleAddEmail}
          value={selectedEmails}
          isValidNewOption={(inputValue) => emailRegex.test(inputValue)}
          formatCreateLabel={(inputValue) =>
            `${getLocalizedString("ORDER_EMAIL_ADD")} "${inputValue}"`
          }
          styles={selectStyle}
        />
        {errors.map((error) => (
          <Box sx={{ color: "crimson", fontSize: ".8em" }}>{error}</Box>
        ))}
      </Box>
    </Flex>
  );
};

export default SelectOrderEmail;

const MultiValueRemove = (props) => {
  //adg 09/10/2024 per togliere la x per cancellare le mail 
  // if (props.data.isDefault) {
  //   return null;
  // }
  return <components.MultiValueRemove {...props} />;
};
